import { getSubstringIndices } from './getSubstringIndices'
import { isNonEmptyString } from './checks'

export const splitHtmlAtH2 = (htmlContent) => {
  if (!isNonEmptyString(htmlContent)) {
    return [] // Return an empty array if the input is an empty string
  }

  const h2Indices = getSubstringIndices(htmlContent, '<h2')

  if (h2Indices.length > 0) {
    const splitParts = []
    let prevIndex = 0

    for (const h2Index of h2Indices) {
      const part = htmlContent.substring(prevIndex, h2Index)
      if (part.length > 0) {
        splitParts.push(part)
      }
      prevIndex = h2Index
    }

    splitParts.push(htmlContent.substring(prevIndex))

    return splitParts
  } else {
    return [htmlContent]
  }
}
